import React from 'react';

export const ThemeProvider = ({ children }) => {
  return (
    <div className="space-designs-theme">
      {children}
    </div>
  );
};




